import { PLATFORM_LOGO } from "../constant";

const Logo = () => {
    return (
        <div className="h-10">
            <img
                src={PLATFORM_LOGO}
                alt="GMF"
                className="h-full object-contain"
            />
        </div>
    );
};

export default Logo;
